import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useAuth();

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleAdminClick = () => {
    navigate('/admin');
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="container header-inner">
        <button
          type="button"
          onClick={handleLogoClick}
          className="header-logo-button"
          aria-label="Перейти на главную"
        >
          <img src="/logo/logo.svg" alt="aivion" className="header-logo" />
        </button>
        <div className="header-user-menu">
          <div className="header-notifications">
            <img
              src="/icons/header/notf.svg"
              alt="Notifications"
              className="header-bell"
            />
            <span className="header-badge">3</span>
          </div>
          {isAdmin && (
            <button type="button" className="header-admin-link" onClick={handleAdminClick}>
              Админ
            </button>
          )}
          {user && (
            <div className="header-balance" aria-label="Баланс">
              {(user.balance ?? 0).toLocaleString('ru-RU')} ₽
            </div>
          )}
          <button
            type="button"
            className="header-username"
            onClick={handleProfileClick}
          >
            {user?.name || 'Пользователь'}
          </button>
          <button className="header-logout" onClick={handleLogout}>
            <span>Выйти</span>
            <img
              src="/icons/logout.svg"
              alt="Выйти"
              className="header-logout-icon"
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
